import React from "react";

export default function Title({ name, custom = ''}) {
  return (
    <p className={`text-[var(--main-color)] text-center text-lg mt-4 animate-fadein ${custom}`}>
      {name}
    </p>
  );
}
